var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgCheck = function SvgCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M18.93 2.813h-1.56a.71.71 0 0 0-.56.272L7.605 14.743 3.193 9.152a.71.71 0 0 0-.56-.273h-1.56a.178.178 0 0 0-.141.288l6.114 7.746a.717.717 0 0 0 1.122 0L19.07 3.098a.177.177 0 0 0-.14-.285"
  })));
};
export default SvgCheck;